module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-proficiency"
  }, [_c('NavigationBar'), _vm._v(" "), _c('div', {
    staticClass: "proficiency-header"
  }, [_c('div', {
    staticClass: "header-title"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('proficiency.title', {
    user: _vm.isParentUser ? _vm.$t('common.child') : _vm.$t('common.me')
  })) + "\n    ")]), _vm._v(" "), _c('SubHeaderTab', {
    attrs: {
      "items": _vm.filterSubjects,
      "selectedId": _vm.selectedSubjectId
    },
    on: {
      "selectedTab": _vm.selectedTab
    }
  })], 1), _vm._v(" "), (_vm.busy) ? [_c('LoadingBounce')] : [_c('div', {
    staticClass: "proficiency-container"
  }, [_c('div', {
    staticClass: "chart-container",
    style: ({
      'background-color': _vm.selectedChartBackgroundColor
    })
  }, [_c('div', {
    staticClass: "chart-description"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('proficiency.chart_title', {
    user: _vm.isParentUser ? _vm.$t('common.child') : _vm.$t('common.me')
  })) + "\n        ")]), _vm._v(" "), _c('CatProficiencyChart', {
    attrs: {
      "chartData": _vm.chartData,
      "chartFontColor": _vm.chartFontColor,
      "height": 160
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center"
  }, [_c('CatScore', {
    attrs: {
      "selectedSubjectId": _vm.selectedSubject,
      "selectedSubjectColor": _vm.selectedChartBackgroundColor
    }
  }), _vm._v(" "), _c('CatSubjectRank', {
    attrs: {
      "selectedSubjectId": _vm.selectedSubject
    }
  })], 1), _vm._v(" "), _c('CatRankPolicy'), _vm._v(" "), (_vm.isSelectedSubjectId) ? [(_vm.filterCatSubjectDomains.length > 0) ? _c('div', {
    staticClass: "domain-container"
  }, [_c('div', {
    staticClass: "cl-title"
  }, [_vm._v(_vm._s(_vm.$t('common.domain')) + " " + _vm._s(_vm.filterCatSubjectDomains.length))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.filterCatSubjectDomains), function(value, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-4 col-xs-12 col-md-12 px-6 domain",
      on: {
        "click": function($event) {
          return _vm.goToLearningElement(value.id)
        }
      }
    }, [_c('div', {
      staticClass: "cl-card"
    }, [_c('div', {
      staticClass: "domain-name"
    }, [_vm._v(_vm._s(value.name))]), _vm._v(" "), _c('div', {
      staticClass: "domain-state"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.score')) + " "), _c('span', [_vm._v(_vm._s(value.proficiency_score || '-') + _vm._s(_vm.$t('common.score_value')))]), _vm._v("     " + _vm._s(_vm.$t('common.rank')) + "\n                  "), (_vm.isGradeTotal(value.rank && value.rank.grade_total)) ? [_c('span', [_vm._v(_vm._s(_vm.ratioValue(value.rank && value.rank.grade_position, value.rank && value.rank.grade_total) || '-') + "%")])] : [_c('span', {
      style: ({
        'color': '#00C896'
      })
    }, [_vm._v("-%")]), _vm._v(" " + _vm._s(_vm.$t('common.standard_before_update')) + "\n                  ")]], 2)])])
  }), _vm._v(" "), (_vm.isFilterCatSubjectDomains) ? _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })]) : _vm._e()], 2)]) : _vm._e()] : _vm._e()], 2)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-562bfc26","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-proficiency/views/CatProficiency.vue
// module id = 1576
// module chunks = 1